import React, { useEffect, useRef, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from './ui/button';
import { Sheet, SheetContent } from './ui/sheet';
import ContactModal from './ContactModal';

import './MobileHeader.css';

export default function MobileHeader() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const lastY = lastScrollYRef.current;

      if (currentY <= 12) {
        setIsHeaderVisible(true);
      } else if (currentY < lastY - 6) {
        setIsHeaderVisible(true);
      } else if (currentY > lastY + 6) {
        setIsHeaderVisible(false);
      }

      lastScrollYRef.current = currentY;
    };

    lastScrollYRef.current = window.scrollY;
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className={`mobileHeader ${isHeaderVisible ? 'mobileHeader--visible' : 'mobileHeader--hidden'}`}>
        <div className="h-16 px-4 flex items-center justify-between">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 bg-transparent border-0 p-0"
          >
            <img src="/Logo.svg" alt="Longfloat Logo" className="w-7 h-7 object-contain" />
            <span className="text-xl font-light tracking-tight text-gray-900">Longfloat</span>
          </button>

          <button
            type="button"
            aria-label="Open menu"
            className="w-15 h-15 rounded-full bg-white/85 shadow-sm flex items-center justify-center text-slate-900"
            onClick={() => setMobileMenuOpen((v) => !v)}
          >
            {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent side="right" className="z-[120]">
          <div className="flex flex-col gap-4 pt-10">
            <a
              href="#products"
              className="text-base font-medium text-slate-600 hover:text-gray-900 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Products
            </a>

            <div className="pt-2 border-t border-slate-200/70" />

            <Button
              variant="outline"
              className="text-sm border-gray-200 hover:border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-lg w-full"
              onClick={() => {
                setMobileMenuOpen(false);
                setIsContactOpen(true);
              }}
            >
              Contact
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      <ContactModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />
    </>
  );
}
